export {MaterialSettingsGeneralTab} from './general/MaterialSettingsGeneralTab'
export {MaterialSettingsProductsTab} from './products/MaterialSettingsProductsTab'
export {MaterialSettingsLimsMaterialsTab} from './lims-materials/MaterialSettingsLimsMaterialsTab/MaterialSettingsLimsMaterialsTab'
export {MaterialSettingsRecipesTab} from './recipes/MaterialSettingsRecipesTab'
export {MaterialSettingsPxTrendTab} from './pxtrend/MaterialSettingsPxTrendTab'
export {MaterialSettingsClassificationTab} from './classification/MaterialSettingsClassificationTab'
export {MaterialSettingsTargetsTab} from './targets/MaterialSettingsTargetsTab'
